/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { AppContextData } from '../interfaces';

export const AppContext = React.createContext<AppContextData>({} as AppContextData);
